import {
    GradingSchemaAction,
    GradingSchemaActionType,
} from '../actionTypes/gradingSchemas';
import { GradingSchema } from '../types';

const GradingSchemasReducer = (
    state: Array<GradingSchema> = [],
    action: GradingSchemaAction
) => {
    switch (action.type) {
        case GradingSchemaActionType.GET_GRADING_SCHEMAS:
            return action.payload;
        case GradingSchemaActionType.UPDATE_GRADING_SCHEMA:
            return state.map((gradingSchema: GradingSchema) => {
                const newGradingSchema = action.payload as GradingSchema;
                if (gradingSchema._id === newGradingSchema._id) {
                    return newGradingSchema;
                } else {
                    return gradingSchema;
                }
            });
        case GradingSchemaActionType.CREATE_GRADING_SCHEMA:
            return [...state, action.payload];
        case GradingSchemaActionType.DELETE_GRADING_SCHEMA: {
            const updatedState = state.filter(
                (rubric) => rubric._id !== action.payload._id
            );
            return [...updatedState];
        }
        default:
            return state;
    }
};

export default GradingSchemasReducer;
